import { UserPlus, Users } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { UserAssignmentEmpty } from '../../User/UserAssignmentEmpty';
import { UserAssignmentList } from '../../User/UserAssignmentList';
import { BulkAddRoleUsers } from './BulkAddRoleUsers';
import { BulkRemoveRoleUsers } from './BulkRemoveRoleUsers';

type DisplayMode = 'users' | 'non-users';

export interface RoleUsersListProps {
  displaying: DisplayMode;
}

export const RoleUsersList = (props: RoleUsersListProps) => {
  const { roleId } = useParams<{ roleId: string }>();
  const numericRoleId = Number(roleId);
  const invitingUsers = props.displaying === 'non-users';
  const filterKey = invitingUsers ? 'excludeRoleIds' : 'roleIds';

  return (
    <UserAssignmentList
      key={props.displaying}
      empty={
        invitingUsers ? (
          <UserAssignmentEmpty
            message="moonstar.roleUsers.allUsersAssigned"
            to={`/roles/${numericRoleId}/users`}
            icon={<Users />}
            label="moonstar.roleUsers.view.label"
          />
        ) : (
          <UserAssignmentEmpty
            message="moonstar.roleUsers.noUsersAssigned"
            to={`/roles/${numericRoleId}/users/add`}
            icon={<UserPlus />}
            label="moonstar.roleUsers.add.label"
          />
        )
      }
      filter={{ [filterKey]: [numericRoleId] }}
      bulkActionButtons={
        invitingUsers ? (
          <BulkAddRoleUsers roleId={numericRoleId} />
        ) : (
          <BulkRemoveRoleUsers roleId={numericRoleId} />
        )
      }
    />
  );
};
